import { DistributionChannel } from '@phrasee/phrasee-typings/typings/project/project-configuration.types'
import { useQuery } from '@tanstack/react-query'

import { TrackingMetricObject } from 'common/api'
import { cepIntegrationsKeys } from 'common/api/queryKeys/integrationsKeys'

import {
  getCepIntegrationTemplates,
  LabelValueObject,
  TestingMethodology,
} from '../api'

export interface CepTemplateFormatted {
  id: string
  cepName: string
  distributionChannel: DistributionChannelFormatted[]
  description: string
}

export interface DistributionChannelFormatted {
  name: DistributionChannel
  messageType: LabelValueObject[]
  selectionMetrics: LabelValueObject[]
  trackingMetrics: TrackingMetricObject[]
  testingMethodology: TestingMethodology
  testingMethodologyOptions: LabelValueObject[]
}

const useGetCepIntegrationTemplatesQuery = (
  accountId: string,
  isEnabled: boolean
) => {
  const getCepTemplateQuery = useQuery<any, Error, CepTemplateFormatted[]>(
    cepIntegrationsKeys.listCepIntegrationTemplates(),
    () => getCepIntegrationTemplates(accountId),
    {
      select: (data) =>
        data.map((item) => {
          return {
            _id: item._id,
            cepName: item.cep_name,
            description: item.description,
            distributionChannel: item.distribution_channel.map((channel) => {
              const testingMethodologyOptions = channel?.testing_methodology
                ? Object.keys(channel.testing_methodology).map((key) => ({
                    label: key
                      .split('_')
                      .map(
                        (word) => word.charAt(0).toUpperCase() + word.slice(1)
                      )
                      .join(' '),
                    value: key,
                  }))
                : []

              return {
                name: channel.name,
                messageType: channel.message_type,
                selectionMetrics: channel.selection_metrics || [],
                trackingMetrics: channel.tracking_metrics || [],
                testingMethodology: channel.testing_methodology,
                testingMethodologyOptions,
              }
            }),
          }
        }),
      enabled: isEnabled,
    }
  )
  return getCepTemplateQuery
}

export default useGetCepIntegrationTemplatesQuery
